var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"far fa-calendar-exclamation c-coral mr-2"}),_vm._v(_vm._s(_vm.$t('EVENTS.LABEL.CANCELLED')))])}
var staticRenderFns = []

export { render, staticRenderFns }